var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('header',{staticClass:"page__header"},[_c('Kvatro_Header')],1),_c('b-container',[_c('div',{staticClass:"page__body"},[(
          _vm.isAuthenticated && _vm.acceptTime && !_vm.displayNavList && _vm.mxCanViewGeneral
        )?_c('div',{staticClass:"page__navbar"},[_c('NavigationList')],1):_vm._e(),_c('SideNavigation'),_c('div',{class:[
          'page__content',
          { 'page__content--transparent': _vm.changeBackgroundColor },
          { 'w-100': _vm.fullWidth || !_vm.mxCanViewGeneral },
        ]},[_c('div',{staticClass:"d-md-none"},[_c('MobileHeader')],1),(_vm.changeRole)?_c('RoleModal'):_vm._e(),_c('router-view'),(!_vm.areCookiesAgreed)?_c('Cookie'):_vm._e()],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }